<script setup>
import { computed } from 'vue';
const props = defineProps({
  limit: { type: Number, default: null },
  used: { type: Number, default: 0 },
  loading: Boolean,
});
const copy = {
  used: 'Agentes cadastrados',
  limit: 'Limite da conta',
  available: 'Vagas disponíveis',
  unknown: 'Não disponível',
  loading: '…',
  help: 'Administradores e convites pendentes também ocupam vagas na conta.',
};
const available = computed(() =>
  props.limit === null ? null : Math.max(0, props.limit - props.used)
);
</script>

<template>
  <div
    class="grid grid-cols-3 gap-3 rounded-2xl border border-n-weak bg-n-solid-2 p-4"
    aria-live="polite"
  >
    <div>
      <span class="block text-xs text-n-slate-11">{{ copy.used }}</span
      ><strong class="mt-1 block break-words text-xl text-n-slate-12">{{
        loading ? copy.loading : used
      }}</strong>
    </div>
    <div>
      <span class="block text-xs text-n-slate-11">{{ copy.limit }}</span
      ><strong class="mt-1 block break-words text-xl text-n-slate-12">{{
        loading ? copy.loading : (limit ?? copy.unknown)
      }}</strong>
    </div>
    <div>
      <span class="block text-xs text-n-slate-11">{{ copy.available }}</span
      ><strong class="mt-1 block break-words text-xl text-n-brand">{{
        loading ? copy.loading : (available ?? copy.unknown)
      }}</strong>
    </div>
    <p class="col-span-3 m-0 text-xs text-n-slate-11">
      {{ copy.help }}
    </p>
  </div>
</template>
